export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/5640253749f57ce229257494a6b0bc26.svg";